<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="新增面试"
    >
        <div class="container">
            <el-form
                ref="addForm"
                :rules="rules"
                :model="addForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="招聘岗位"
                            size="small"
                            prop="role_id"
                        >
                            <el-select
                                v-model="addForm.role_id"
                                clearable
                                placeholder="请选择招聘岗位"
                                size="small"
                                disabled
                            >
                                <el-option
                                    v-for="item in roleList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="面试时间"
                            size="small"
                            prop="interview_time"
                        >
                            <el-date-picker
                                v-model="addForm.interview_time"
                                type="datetime"
                                placeholder="选择面试时间"
                                value-format="yyyy-MM-dd HH:mm"
                                format="yyyy-MM-dd HH:mm"
                                default-time="10:00:00"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="应聘者姓名"
                            size="small"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入应聘者姓名"
                                maxlength="30"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="应聘者手机号"
                            size="small"
                            prop="phone"
                        >
                            <el-input
                                clearable
                                placeholder="请输入应聘者手机号"
                                maxlength="30"
                                size="small"
                                v-model.number="addForm.phone"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="面试官"
                            size="small"
                            prop="interviewer"
                        >
                            <el-select
                                v-model="addForm.interviewer"
                                clearable
                                placeholder="请选择面试官"
                                size="small"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="邮箱"
                            size="small"
                            prop="email"
                        >
                            <el-input
                                clearable
                                placeholder="请输入应聘者邮箱"
                                size="small"
                                v-model="addForm.email"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="简历文件" size="small" prop="file">
                            <fileUpload ref="fileUpload" @fileUploaded="fileChange" :limit="1"></fileUpload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
import fileUpload from "@/comon/components/fileUpload.vue";
export default {
    data() {
        return {
            addForm: {
                name: "",
                phone: "",
                interview_time: "",
                role_id: "",
                file: "",
                interviewer: "",
                rec_id: "",
                email: ""
            },
            rules: {
                role_id: [
                    {
                        required: true,
                        message: "请选择招聘岗位",
                        trigger: "blur",
                    },
                ],
                interview_time: [
                    {
                        required: true,
                        message: "请选择面试时间",
                        trigger: "blur",
                    },
                ],
                name: [
                    {
                        required: true,
                        message: "请输入应聘者姓名",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入应聘者手机号",
                        trigger: "blur",
                    },
                    { pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/, message: "手机号格式有误" }
                ],
                file: [
                    {
                        required: true,
                        message: "请上传简历文件",
                        trigger: "blur",
                    },
                ],
                interviewer: [
                    {
                        required: true,
                        message: "请选择面试官",
                        trigger: "change",
                    },
                ],
            },
            staffList: [],
        };
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (newValue) {
                    this.addForm.rec_id = this.tableItem.id;
                    this.getRoleList();
                    this.getStaffSelect();
                }
            },
        },
    },
    created() {},
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    oaApi.interview({ ...this.addForm }, "post").then((res) => {
                        if (res) {
                            this.$parent.recruitment();                              this.closeDialog();
                            this.closeDialog();
                            this.$message.success("新增成功!");
                        }
                    });
                }
            });
        },
        getRoleList() {
            oaApi.roleSelect({}, "get").then((res) => {
                if (res.code == 200) {
                    this.roleList = res.data;
                    this.addForm.role_id = this.tableItem.role_id;
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:addVisible", false);
            this.$refs["addForm"].resetFields();
            this.$refs["addForm"].clearValidate();
            // 清除上一次简历文件
            this.$refs.fileUpload.clearFiles();
        },
        fileChange(data) {
            //console.log(data);
            this.addForm.file = data;
            this.$refs["addForm"].clearValidate("file");
        },
        getStaffSelect() {
            oaApi.select({}, "get").then((res) => {
                if (res) {
                    //console.log(res);
                    this.staffList = res.data;
                }
            });
        },
    },
    components: {
        fileUpload,
    },
    computed:{
        ...mapState({
            pickerOptions: (state) => state.index.pickerOptions,
        })
    }
};
</script>

<style lang="scss" scoped>
.add {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>